export type Highlight = Readonly<{ text: string }>;

export enum ConciergeInvitationProduct {
  ByronGatefold = 'byronGatefold',
  Celadon = 'celadon',
  Eden = 'eden',
  EmpireNow = 'empireNow',
  Flutter = 'flutter',
  Grace = 'grace',
  GraceTrifold = 'graceTrifold',
  Harmony = 'harmony',
  HarmonyGatefold = 'harmonyGatefold',
  Ivory = 'ivory',
  Jardin = 'jardin',
  JulyTrifold = 'julyTrifold',
  Koffee = 'koffee',
  Luminous = 'luminous',
  MilkAndHoney = 'milkAndHoney',
  RoseEtGris = 'roseEtGris',
  Sage = 'sage',
  Sofia = 'sofia',
  Together = 'together',
  WildestDream = 'wildestDream',
  WildMeadow = 'wildMeadow',
  MeetYouAtTheArch = 'meetYouAtTheArch',
  DelicateLuxe = 'delicateLuxe',
  LavenderLeaves = 'lavenderLeaves',
  WhiteGarden = 'whiteGarden',
  GoldFoilFrame = 'goldFoilFrame',
  GardenWindow = 'gardenWindow',
  LoveAndLeaves = 'loveAndLeaves',
  LunaGatefold = 'lunaGatefold',
  Eucalyptus = 'eucalyptus',
  GraphiteBlooms = 'graphiteBlooms',
  ModernSimplicity = 'modernSimplicity',
  IvoryGarden = 'ivoryGarden',
  GardenEstate = 'gardenEstate',
  BotanicalGeo = 'botanicalGeo',
}

export enum ConciergeSaveTheDateProduct {
  Byron = 'byron',
  ClairDeLune = 'clairDeLune',
  Delilah = 'delilah',
  Floweret = 'floweret',
  Linear = 'linear',
  Luna = 'luna',
  Minimalisme = 'minimalisme',
  MinimalistBlackWhite = 'minimalistBlackWhite',
  Polaroid = 'polaroid',
  SummerMontage = 'summerMontage',
  SummerNights = 'summerNights',
}

const CONCIERGE_INVITATION_PRODUCT_SET: ReadonlySet<string> = new Set(Object.values(ConciergeInvitationProduct)) as ReadonlySet<string>;

const CONCIERGE_SAVE_THE_DATE_PRODUCT_SET: ReadonlySet<string> = new Set(Object.values(ConciergeSaveTheDateProduct)) as ReadonlySet<string>;

export const isConciergeDesignSetName = (designSetName: string): designSetName is ConciergeInvitationProduct | ConciergeSaveTheDateProduct => {
  return CONCIERGE_INVITATION_PRODUCT_SET.has(designSetName) || CONCIERGE_SAVE_THE_DATE_PRODUCT_SET.has(designSetName);
};

export type ProductOffering = Readonly<{
  id: ConciergeInvitationProduct | ConciergeSaveTheDateProduct;
  identifier: ConciergeInvitationProduct | ConciergeSaveTheDateProduct;
  typeformId: string;
  shortName: string;
  longName: string;
  costPerHundredString: string;
  descriptionHighlights: ReadonlyArray<Highlight>;
  imageUrl: string;
  suiteHighlights?: ReadonlyArray<Highlight>;
  printingBusinessDaysQuantity: number;
}> &
  (
    | Readonly<{ videoUrl: string; videoThumbnailUrl: string }> // Complete with video
    | Readonly<{ videoUrl?: never; videoThumbnailUrl?: never }> // No video
  );

export type OnCustomizeOfferingClickHandler = (offering: Readonly<ProductOffering>) => void;
